export const FormatZip = angular
    .module('checkout.directives.formatZip', []).directive('formatZip', () => {
        return {
            require: '?ngModel',
            link: (scope, element, attrs, ngModelController) => {
                if (!ngModelController) {
                    return;
                }

                const formatZip = (value) => {
                    if (value === undefined) return '';
                    value = value.toString();
                    value = value.replace(/[^0-9]/g, '');
                    if (value.length > 9) {
                        value = value.slice(0, 9);
                    }
                    if (value.length > 5) {
                        value = `${value.slice(0, 5)}-${value.slice(5)}`;
                    }

                    return value;
                };

                const stripNonNumericCharacters = (inputValue) => {
                    if (!inputValue) {
                        return '';
                    }

                    // retrieve numbers from the string
                    const numbersOnly = inputValue.replace(/[^\d]*/g, '');

                    // if the input does not match expected value.. change the rendered view to correct format
                    if (numbersOnly !== inputValue) {
                        ngModelController.$setViewValue(numbersOnly); // view value is updated
                        ngModelController.$render(); // view is updated
                    }

                    // return only the numbers from string
                    return numbersOnly;
                };

                ngModelController.$parsers.unshift((value) => {
                    const viewValue = formatZip(stripNonNumericCharacters(value));
                    element.val(viewValue);
                    return viewValue;
                });

                ngModelController.$formatters.unshift(() => {
                    return ngModelController.$modelValue;
                });
            }
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/directives/formatZip.js